<div class="details-pane" h3ScrollEnabler>
  <ng-container *ngFor="let attribute of focusedAnnotationAttributes$ | async">
    <ng-container [ngSwitch]="attribute.__type">
      <h3-boolean-attribute-input
        *ngSwitchCase="'boolean_attribute'"
        [attribute]="attribute"
        [annotationStore]="focusedAnnotationStore$ | async"
      ></h3-boolean-attribute-input>
      <h3-choice-attribute-input
        *ngSwitchCase="'single_choice_attribute'"
        [multiple]="false"
        [attribute]="attribute"
        [annotationStore]="focusedAnnotationStore$ | async"
      ></h3-choice-attribute-input>
      <h3-choice-attribute-input
        *ngSwitchCase="'multiple_choice_attribute'"
        [multiple]="true"
        [attribute]="attribute"
        [annotationStore]="focusedAnnotationStore$ | async"
      ></h3-choice-attribute-input>
      <h3-text-attribute-input
        *ngSwitchCase="'text_attribute'"
        [attribute]="attribute"
        [annotationStore]="focusedAnnotationStore$ | async"
      ></h3-text-attribute-input>
    </ng-container>
  </ng-container>
</div>
